import { IconType } from "./icons.types";

export const PendingIcon = ({ className, color = "#FF4C51" }: IconType) => {
  return (
    <svg
      width="38"
      height="40"
      viewBox="0 0 38 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        opacity="0.78"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.1682 12.7451C17.1949 12.3977 17.4846 12.1295 17.8329 12.1295H18.39C18.7325 12.1295 19.0193 12.389 19.0534 12.7298L19.8822 21.0184L25.7685 24.382C25.9763 24.5007 26.1044 24.7216 26.1044 24.9608V25.4789C26.1044 25.9185 25.6865 26.2377 25.2624 26.1221L16.8582 23.83C16.5497 23.7459 16.3444 23.4546 16.3689 23.1357L17.1682 12.7451Z"
        fill={color}
      />
      <path
        opacity="0.901274"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.28901 0.979164C8.93687 0.5595 8.25695 0.720127 8.12984 1.25301L5.95189 10.3839C5.84832 10.8181 6.19241 11.2294 6.63808 11.2041L16.0311 10.6719C16.579 10.6408 16.8568 9.9981 16.5041 9.57773L14.1022 6.71525C15.6553 6.18452 17.3022 5.90732 18.9933 5.90732C27.339 5.90732 34.1044 12.6728 34.1044 21.0184C34.1044 29.3641 27.339 36.1295 18.9933 36.1295C10.6477 36.1295 3.88222 29.3641 3.88222 21.0184C3.88222 19.6174 4.07194 18.2452 4.44188 16.9264L1.01845 15.9661C0.567717 17.573 0.32666 19.2676 0.32666 21.0184C0.32666 31.3277 8.68401 39.6851 18.9933 39.6851C29.3026 39.6851 37.66 31.3277 37.66 21.0184C37.66 10.7091 29.3026 2.35176 18.9933 2.35176C16.4002 2.35176 13.9305 2.88053 11.6863 3.83613L9.28901 0.979164Z"
        fill={color}
      />
    </svg>
  );
};
